import styled from "styled-components";

const InputGroup = styled.div`
    margin: 0 0 15px 0;

    label {
        margin-left: 10px;
        font-size: 13px;
    }
`;

type CheckboxInputProps = {
    name: string;
    label?: string;
    onChange: (name: string, value: boolean) => void;
    onBlur?: (name: string, value: boolean) => void;
    value?: boolean;
    error?: string;
    required?: boolean;
    description?: string;
    [key: string]: any;
};

const CheckboxInput = ({
    name,
    label,
    onChange,
    onBlur = null,
    required = false,
    value = false,
    error = "",
    description = "",
    ...props
}: CheckboxInputProps) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        onChange(name, checked);
    };

    const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!onBlur) {
            return;
        }

        const { name, checked } = e.target;
        onBlur(name, checked);
    };

    return (
        <InputGroup className="form-group">
            <input
                {...props}
                name={name}
                id={name}
                type="checkbox"
                className="form-control"
                onChange={handleChange}
                onBlur={handleBlur}
                checked={value}
                disabled={props.disabled}
            />
            {label ? (
                <label htmlFor={name}>
                    {label}
                    {required ? " *" : ""}
                </label>
            ) : (
                ""
            )}
            <div>{description ? <small>{description}</small> : ""}</div>
            <div>{error ? <span className="field-error small">{error}</span> : ""}</div>
        </InputGroup>
    );
};

export default CheckboxInput;
